<template>
  <div class="offline-meeting-template" theme>
    <div id="offline-meeting-content" />
  </div>
</template>
<script>
export default {
  watch: {
    '$route.query.category': {
      handler: function(newVal, oldVal) {
        if (newVal) {
          $('body').attr('offline-meeting-category', newVal)
        }
      }
    }
  },
  mounted() {
    $('body').removeAttr('offline-meeting-category')
    if (this.$route.query.category) {
      $('body').attr('offline-meeting-category', this.$route.query.category)
    }
  },
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-content',
          htmlFile: 'list'
        }
      ]
    }
  }
}
</script>
